var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Book = function Book(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.586 3.586A2 2 0 0 1 6 3h11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-7v1a1 1 0 1 1-2 0v-1H6a2 2 0 0 1-2-2V5a2 2 0 0 1 .586-1.414ZM10 19h7a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-7v14ZM8 5v14H6V5h2Zm4 3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Book;